import styles from "./Desktop94.module.css";

const Desktop94 = () => {
  return (
    <div className={styles.desktop94}>
      <div className={styles.beautifulPurpleUniverseBackParent}>
        <img
          className={styles.beautifulPurpleUniverseBackIcon}
          alt=""
          src="/beautifulpurpleuniversebackground-1@2x.png"
        />
        <div className={styles.groupChild} />
      </div>
      <div className={styles.homeParent}>
        <div className={styles.home}>Home</div>
        <div className={styles.callWithAstrologer}>Call with Astrologer</div>
        <div className={styles.callWithAstrologer}>{`Live (Coming Soon) `}</div>
      </div>
      <div className={styles.desktop94Inner}>
        <img className={styles.frameChild} alt="" src="/ellipse-11@2x.png" />
      </div>
      <div className={styles.desktop94Child}>
        <div className={styles.ellipseParent}>
          <img className={styles.groupItem} alt="" src="/ellipse-1551.svg" />
          <div className={styles.gurji}>Guruji</div>
          <div className={styles.groupInner} />
          <img className={styles.groupIcon} alt="" src="/group-50778.svg" />
          <img className={styles.layer3Icon} alt="" src="/layer-3.svg" />
          <img className={styles.objectsIcon} alt="" src="/objects.svg" />
        </div>
      </div>
      <div className={styles.frameParent}>
        <div className={styles.astrologyForClarityParent}>
          <b className={styles.astrologyForClarity}>“Astrology for Clarity”</b>
          <div
            className={styles.yourNameIs}
          >{`Your Name is a Vedic Astrologer and has expertise in Vaastu and Mantra Theraphy `}</div>
        </div>
        <div className={styles.component40Wrapper}>
          <div className={styles.component40}>
            <div className={styles.rectangleParent}>
              <div className={styles.rectangleDiv} />
              <div className={styles.consultNow}>Consult Now</div>
            </div>
          </div>
        </div>
      </div>
      <div className={styles.vectorParent}>
        <img className={styles.vectorIcon} alt="" src="/vector.svg" />
        <div className={styles.frameGroup}>
          <img className={styles.frameIcon} alt="" src="/frame-48096295.svg" />
          <div className={styles.frameContainer}>
            <div className={styles.rectangleWrapper}>
              <div className={styles.frameItem} />
            </div>
            <div className={styles.frameWrapper}>
              <div className={styles.frameDiv}>
                <div className={styles.vectorGroup}>
                  <img
                    className={styles.vectorIcon1}
                    alt=""
                    src="/vector1.svg"
                  />
                  <b className={styles.premiumAstrologers}>
                    Premium Astrologers
                  </b>
                  <img
                    className={styles.vectorIcon1}
                    alt=""
                    src="/vector1.svg"
                  />
                </div>
                <div className={styles.groupDiv}>
                  <div className={styles.groupWrapper}>
                    <div className={styles.maskGroupParent}>
                      <img
                        className={styles.maskGroupIcon}
                        alt=""
                        src="/mask-group@2x.png"
                      />
                      <div className={styles.groupChild1} />
                      <div className={styles.groupChild2} />
                      <div className={styles.frameWrapper1}>
                        <div className={styles.groupContainer}>
                          <div className={styles.frameWrapper2}>
                            <div className={styles.frameWrapper3}>
                              <div className={styles.frameWrapper4}>
                                <div />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className={styles.div}>10+ Years</div>
                      <div className={styles.groupParent}>
                        <div className={styles.rectangleGroup}>
                          <div className={styles.rectangle} />
                          <b className={styles.online}>Online</b>
                        </div>
                        <img
                          className={styles.ellipseIcon}
                          alt=""
                          src="/ellipse-1528.svg"
                        />
                      </div>
                      <div className={styles.frameParent1}>
                        <div className={styles.astrologerRamrajWrapper}>
                          <div className={styles.astrologerRamraj}>
                            Astrologer Ramraj
                          </div>
                        </div>
                        <div className={styles.frameParent2}>
                          <div className={styles.groupContainer}>
                            <div className={styles.div1}>Specialties</div>
                            <div className={styles.wrapper}>
                              <div
                                className={styles.div2}
                              >{`Love, Business, Life `}</div>
                            </div>
                          </div>
                          <div className={styles.groupContainer}>
                            <div className={styles.div3}>Skills</div>
                            <div
                              className={styles.div4}
                            >{`Vedic Astrology, Kundali, `}</div>
                          </div>
                        </div>
                      </div>
                      <div className={styles.container}>
                        <div className={styles.div2}>Price</div>
                        <div className={styles.frameWrapper5}>
                          <div className={styles.groupFrame}>
                            <div className={styles.statusbusyqueueParent}>
                              <b className={styles.statusbusyqueue}>₹10</b>
                              <b className={styles.min}>/min</b>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className={styles.groupParent1}>
                        <img
                          className={styles.groupChild3}
                          alt=""
                          src="/group-51133.svg"
                        />
                        <div className={styles.iconsaxoutlinecallParent}>
                          <img
                            className={styles.iconsaxoutlinecall}
                            alt=""
                            src="/iconsaxoutlinecall.svg"
                          />
                          <b className={styles.call}>Call</b>
                        </div>
                        <div className={styles.iconsaxoutlinemessageParent}>
                          <img
                            className={styles.iconsaxoutlinecall}
                            alt=""
                            src="/iconsaxoutlinemessage.svg"
                          />
                          <b className={styles.call}>Chat</b>
                        </div>
                      </div>
                      <div className={styles.lineDiv} />
                    </div>
                  </div>
                  <div className={styles.groupWrapper1}>
                    <div className={styles.maskGroupGroup}>
                      <img
                        className={styles.maskGroupIcon}
                        alt=""
                        src="/mask-group1@2x.png"
                      />
                      <div className={styles.groupChild1} />
                      <div className={styles.groupChild2} />
                      <div className={styles.frameWrapper1}>
                        <div className={styles.groupContainer}>
                          <div className={styles.frameWrapper2}>
                            <div className={styles.frameWrapper3}>
                              <div className={styles.frameWrapper4}>
                                <div />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className={styles.div}>10+ Years</div>
                      <div className={styles.groupParent}>
                        <div className={styles.rectangleGroup}>
                          <div className={styles.rectangle} />
                          <b className={styles.online}>Online</b>
                        </div>
                        <img
                          className={styles.ellipseIcon}
                          alt=""
                          src="/ellipse-15281.svg"
                        />
                      </div>
                      <div className={styles.frameParent1}>
                        <div className={styles.astrologerRamrajWrapper}>
                          <div className={styles.astrologerRamraj}>
                            Astrologer Ramraj
                          </div>
                        </div>
                        <div className={styles.frameParent2}>
                          <div className={styles.groupContainer}>
                            <div className={styles.div1}>Specialties</div>
                            <div className={styles.wrapper}>
                              <div
                                className={styles.div2}
                              >{`Love, Business, Life `}</div>
                            </div>
                          </div>
                          <div className={styles.groupContainer}>
                            <div className={styles.div3}>Skills</div>
                            <div
                              className={styles.div4}
                            >{`Vedic Astrology, Kundali, `}</div>
                          </div>
                        </div>
                      </div>
                      <div className={styles.container}>
                        <div className={styles.div2}>Price</div>
                        <div className={styles.frameWrapper5}>
                          <div className={styles.groupFrame}>
                            <div className={styles.statusbusyqueueParent}>
                              <b className={styles.statusbusyqueue}>₹10</b>
                              <b className={styles.min}>/min</b>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className={styles.groupParent1}>
                        <img
                          className={styles.groupChild3}
                          alt=""
                          src="/group-511331.svg"
                        />
                        <div className={styles.iconsaxoutlinecallParent}>
                          <img
                            className={styles.iconsaxoutlinecall}
                            alt=""
                            src="/iconsaxoutlinecall1.svg"
                          />
                          <b className={styles.call}>Call</b>
                        </div>
                        <div className={styles.iconsaxoutlinemessageParent}>
                          <img
                            className={styles.iconsaxoutlinecall}
                            alt=""
                            src="/iconsaxoutlinemessage1.svg"
                          />
                          <b className={styles.call}>Chat</b>
                        </div>
                      </div>
                      <div className={styles.lineDiv} />
                    </div>
                  </div>
                  <div className={styles.frameParent5}>
                    <div className={styles.groupWrapper4}>
                      <div className={styles.maskGroupGroup}>
                        <img
                          className={styles.maskGroupIcon2}
                          alt=""
                          src="/mask-group2@2x.png"
                        />
                        <div className={styles.groupChild9} />
                        <div className={styles.groupChild10} />
                        <div className={styles.frameWrapper1}>
                          <div className={styles.groupContainer}>
                            <div className={styles.frameWrapper2}>
                              <div className={styles.frameWrapper3}>
                                <div className={styles.frameWrapper4}>
                                  <div />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className={styles.div12}>10+ Years</div>
                        <div className={styles.groupParent}>
                          <div className={styles.rectangleGroup}>
                            <div className={styles.rectangle} />
                            <b className={styles.online}>Online</b>
                          </div>
                          <img
                            className={styles.ellipseIcon}
                            alt=""
                            src="/ellipse-15282.svg"
                          />
                        </div>
                        <div className={styles.frameParent6}>
                          <div className={styles.astrologerRamrajWrapper}>
                            <div className={styles.astrologerRamraj}>
                              Astrologer Ramraj
                            </div>
                          </div>
                          <div className={styles.frameParent2}>
                            <div className={styles.groupContainer}>
                              <div className={styles.div1}>Specialties</div>
                              <div className={styles.wrapper}>
                                <div
                                  className={styles.div2}
                                >{`Love, Business, Life `}</div>
                              </div>
                            </div>
                            <div className={styles.groupContainer}>
                              <div className={styles.div3}>Skills</div>
                              <div
                                className={styles.div4}
                              >{`Vedic Astrology, Kundali, `}</div>
                            </div>
                          </div>
                        </div>
                        <div className={styles.container}>
                          <div className={styles.div2}>Price</div>
                          <div className={styles.frameWrapper5}>
                            <div className={styles.groupFrame}>
                              <div className={styles.statusbusyqueueParent}>
                                <b className={styles.statusbusyqueue}>₹10</b>
                                <b className={styles.min}>/min</b>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className={styles.groupParent1}>
                          <img
                            className={styles.groupChild3}
                            alt=""
                            src="/group-511332.svg"
                          />
                          <div className={styles.iconsaxoutlinecallParent}>
                            <img
                              className={styles.iconsaxoutlinecall}
                              alt=""
                              src="/iconsaxoutlinecall1.svg"
                            />
                            <b className={styles.call}>Call</b>
                          </div>
                          <div className={styles.iconsaxoutlinemessageParent}>
                            <img
                              className={styles.iconsaxoutlinecall}
                              alt=""
                              src="/iconsaxoutlinemessage2.svg"
                            />
                            <b className={styles.call}>Chat</b>
                          </div>
                        </div>
                        <div className={styles.lineDiv} />
                      </div>
                    </div>
                    <div className={styles.groupWrapper7}>
                      <div className={styles.maskGroupGroup}>
                        <img
                          className={styles.maskGroupIcon}
                          alt=""
                          src="/mask-group3@2x.png"
                        />
                        <div className={styles.groupChild1} />
                        <div className={styles.groupChild2} />
                        <div className={styles.frameWrapper1}>
                          <div className={styles.groupContainer}>
                            <div className={styles.frameWrapper2}>
                              <div className={styles.frameWrapper3}>
                                <div className={styles.frameWrapper4}>
                                  <div />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className={styles.div}>10+ Years</div>
                        <div className={styles.groupParent}>
                          <div className={styles.rectangleGroup}>
                            <div className={styles.rectangle} />
                            <b className={styles.online}>Online</b>
                          </div>
                          <img
                            className={styles.ellipseIcon}
                            alt=""
                            src="/ellipse-15282.svg"
                          />
                        </div>
                        <div className={styles.frameParent6}>
                          <div className={styles.astrologerRamrajWrapper}>
                            <div className={styles.astrologerRamraj}>
                              Astrologer Ramraj
                            </div>
                          </div>
                          <div className={styles.frameParent2}>
                            <div className={styles.groupContainer}>
                              <div className={styles.div1}>Specialties</div>
                              <div className={styles.wrapper}>
                                <div
                                  className={styles.div2}
                                >{`Love, Business, Life `}</div>
                              </div>
                            </div>
                            <div className={styles.groupContainer}>
                              <div className={styles.div3}>Skills</div>
                              <div
                                className={styles.div4}
                              >{`Vedic Astrology, Kundali, `}</div>
                            </div>
                          </div>
                        </div>
                        <div className={styles.container}>
                          <div className={styles.div2}>Price</div>
                          <div className={styles.frameWrapper5}>
                            <div className={styles.groupFrame}>
                              <div className={styles.statusbusyqueueParent}>
                                <b className={styles.statusbusyqueue}>₹10</b>
                                <b className={styles.min}>/min</b>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className={styles.groupParent1}>
                          <img
                            className={styles.groupChild3}
                            alt=""
                            src="/group-511333.svg"
                          />
                          <div className={styles.iconsaxoutlinecallParent}>
                            <img
                              className={styles.iconsaxoutlinecall}
                              alt=""
                              src="/iconsaxoutlinecall1.svg"
                            />
                            <b className={styles.call}>Call</b>
                          </div>
                          <div className={styles.iconsaxoutlinemessageParent}>
                            <img
                              className={styles.iconsaxoutlinecall}
                              alt=""
                              src="/iconsaxoutlinemessage2.svg"
                            />
                            <b className={styles.call}>Chat</b>
                          </div>
                        </div>
                        <div className={styles.lineDiv} />
                      </div>
                    </div>
                    <div className={styles.groupWrapper10}>
                      <div className={styles.maskGroupGroup}>
                        <img
                          className={styles.maskGroupIcon}
                          alt=""
                          src="/mask-group4@2x.png"
                        />
                        <div className={styles.groupChild1} />
                        <div className={styles.groupChild2} />
                        <div className={styles.frameWrapper1}>
                          <div className={styles.groupContainer}>
                            <div className={styles.frameWrapper2}>
                              <div className={styles.frameWrapper3}>
                                <div className={styles.frameWrapper4}>
                                  <div />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className={styles.div}>10+ Years</div>
                        <div className={styles.groupParent}>
                          <div className={styles.rectangleGroup}>
                            <div className={styles.rectangle} />
                            <b className={styles.online}>Online</b>
                          </div>
                          <img
                            className={styles.ellipseIcon}
                            alt=""
                            src="/ellipse-15282.svg"
                          />
                        </div>
                        <div className={styles.frameParent10}>
                          <div className={styles.astrologerRamrajWrapper}>
                            <div className={styles.astrologerRamraj}>
                              Astrologer Ramraj
                            </div>
                          </div>
                          <div className={styles.frameParent2}>
                            <div className={styles.groupContainer}>
                              <div className={styles.div1}>Specialties</div>
                              <div className={styles.wrapper}>
                                <div
                                  className={styles.div2}
                                >{`Love, Business, Life `}</div>
                              </div>
                            </div>
                            <div className={styles.groupContainer}>
                              <div className={styles.div3}>Skills</div>
                              <div
                                className={styles.div4}
                              >{`Vedic Astrology, Kundali, `}</div>
                            </div>
                          </div>
                        </div>
                        <div className={styles.container}>
                          <div className={styles.div2}>Price</div>
                          <div className={styles.frameWrapper5}>
                            <div className={styles.groupFrame}>
                              <div className={styles.statusbusyqueueParent}>
                                <b className={styles.statusbusyqueue}>₹10</b>
                                <b className={styles.min}>/min</b>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className={styles.groupParent1}>
                          <img
                            className={styles.groupChild3}
                            alt=""
                            src="/group-511334.svg"
                          />
                          <div className={styles.iconsaxoutlinecallParent}>
                            <img
                              className={styles.iconsaxoutlinecall}
                              alt=""
                              src="/iconsaxoutlinecall1.svg"
                            />
                            <b className={styles.call}>Call</b>
                          </div>
                          <div className={styles.iconsaxoutlinemessageParent}>
                            <img
                              className={styles.iconsaxoutlinecall}
                              alt=""
                              src="/iconsaxoutlinemessage3.svg"
                            />
                            <b className={styles.call}>Chat</b>
                          </div>
                        </div>
                        <div className={styles.lineDiv} />
                      </div>
                    </div>
                  </div>
                  <div className={styles.frameParent12}>
                    <div className={styles.groupWrapper4}>
                      <div className={styles.maskGroupGroup}>
                        <img
                          className={styles.maskGroupIcon2}
                          alt=""
                          src="/mask-group5@2x.png"
                        />
                        <div className={styles.groupChild9} />
                        <div className={styles.groupChild10} />
                        <div className={styles.frameWrapper1}>
                          <div className={styles.groupContainer}>
                            <div className={styles.frameWrapper2}>
                              <div className={styles.frameWrapper3}>
                                <div className={styles.frameWrapper4}>
                                  <div />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className={styles.div12}>10+ Years</div>
                        <div className={styles.groupParent}>
                          <div className={styles.rectangleGroup}>
                            <div className={styles.rectangle} />
                            <b className={styles.online}>Online</b>
                          </div>
                          <img
                            className={styles.ellipseIcon}
                            alt=""
                            src="/ellipse-15283.svg"
                          />
                        </div>
                        <div className={styles.frameParent6}>
                          <div className={styles.astrologerRamrajWrapper}>
                            <div className={styles.astrologerRamraj}>
                              Astrologer Ramraj
                            </div>
                          </div>
                          <div className={styles.frameParent2}>
                            <div className={styles.groupContainer}>
                              <div className={styles.div1}>Specialties</div>
                              <div className={styles.wrapper}>
                                <div
                                  className={styles.div2}
                                >{`Love, Business, Life `}</div>
                              </div>
                            </div>
                            <div className={styles.groupContainer}>
                              <div className={styles.div3}>Skills</div>
                              <div
                                className={styles.div4}
                              >{`Vedic Astrology, Kundali, `}</div>
                            </div>
                          </div>
                        </div>
                        <div className={styles.container}>
                          <div className={styles.div2}>Price</div>
                          <div className={styles.frameWrapper5}>
                            <div className={styles.groupFrame}>
                              <div className={styles.statusbusyqueueParent}>
                                <b className={styles.statusbusyqueue}>₹10</b>
                                <b className={styles.min}>/min</b>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className={styles.groupParent1}>
                          <img
                            className={styles.groupChild3}
                            alt=""
                            src="/group-511335.svg"
                          />
                          <div className={styles.iconsaxoutlinecallParent}>
                            <img
                              className={styles.iconsaxoutlinecall}
                              alt=""
                              src="/iconsaxoutlinecall1.svg"
                            />
                            <b className={styles.call}>Call</b>
                          </div>
                          <div className={styles.iconsaxoutlinemessageParent}>
                            <img
                              className={styles.iconsaxoutlinecall}
                              alt=""
                              src="/iconsaxoutlinemessage1.svg"
                            />
                            <b className={styles.call}>Chat</b>
                          </div>
                        </div>
                        <div className={styles.lineDiv} />
                      </div>
                    </div>
                    <div className={styles.groupWrapper10}>
                      <div className={styles.maskGroupGroup}>
                        <img
                          className={styles.maskGroupIcon}
                          alt=""
                          src="/mask-group3@2x.png"
                        />
                        <div className={styles.groupChild1} />
                        <div className={styles.groupChild2} />
                        <div className={styles.frameWrapper1}>
                          <div className={styles.groupContainer}>
                            <div className={styles.frameWrapper2}>
                              <div className={styles.frameWrapper3}>
                                <div className={styles.frameWrapper4}>
                                  <div />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className={styles.div}>10+ Years</div>
                        <div className={styles.groupParent}>
                          <div className={styles.rectangleGroup}>
                            <div className={styles.rectangle} />
                            <b className={styles.online}>Online</b>
                          </div>
                          <img
                            className={styles.ellipseIcon}
                            alt=""
                            src="/ellipse-15283.svg"
                          />
                        </div>
                        <div className={styles.frameParent6}>
                          <div className={styles.astrologerRamrajWrapper}>
                            <div className={styles.astrologerRamraj}>
                              Astrologer Ramraj
                            </div>
                          </div>
                          <div className={styles.frameParent2}>
                            <div className={styles.groupContainer}>
                              <div className={styles.div1}>Specialties</div>
                              <div className={styles.wrapper}>
                                <div
                                  className={styles.div2}
                                >{`Love, Business, Life `}</div>
                              </div>
                            </div>
                            <div className={styles.groupContainer}>
                              <div className={styles.div3}>Skills</div>
                              <div
                                className={styles.div4}
                              >{`Vedic Astrology, Kundali, `}</div>
                            </div>
                          </div>
                        </div>
                        <div className={styles.container}>
                          <div className={styles.div2}>Price</div>
                          <div className={styles.frameWrapper5}>
                            <div className={styles.groupFrame}>
                              <div className={styles.statusbusyqueueParent}>
                                <b className={styles.statusbusyqueue}>₹10</b>
                                <b className={styles.min}>/min</b>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className={styles.groupParent1}>
                          <img
                            className={styles.groupChild3}
                            alt=""
                            src="/group-511335.svg"
                          />
                          <div className={styles.iconsaxoutlinecallParent}>
                            <img
                              className={styles.iconsaxoutlinecall}
                              alt=""
                              src="/iconsaxoutlinecall1.svg"
                            />
                            <b className={styles.call}>Call</b>
                          </div>
                          <div className={styles.iconsaxoutlinemessageParent}>
                            <img
                              className={styles.iconsaxoutlinecall}
                              alt=""
                              src="/iconsaxoutlinemessage1.svg"
                            />
                            <b className={styles.call}>Chat</b>
                          </div>
                        </div>
                        <div className={styles.lineDiv} />
                      </div>
                    </div>
                    <div className={styles.groupWrapper7}>
                      <div className={styles.maskGroupGroup}>
                        <img
                          className={styles.maskGroupIcon}
                          alt=""
                          src="/mask-group6@2x.png"
                        />
                        <div className={styles.groupChild1} />
                        <div className={styles.groupChild2} />
                        <div className={styles.frameWrapper1}>
                          <div className={styles.groupContainer}>
                            <div className={styles.frameWrapper2}>
                              <div className={styles.frameWrapper3}>
                                <div className={styles.frameWrapper4}>
                                  <div />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className={styles.div}>10+ Years</div>
                        <div className={styles.groupParent}>
                          <div className={styles.rectangleGroup}>
                            <div className={styles.rectangle} />
                            <b className={styles.online}>Online</b>
                          </div>
                          <img
                            className={styles.ellipseIcon}
                            alt=""
                            src="/ellipse-15283.svg"
                          />
                        </div>
                        <div className={styles.frameParent10}>
                          <div className={styles.astrologerRamrajWrapper}>
                            <div className={styles.astrologerRamraj}>
                              Astrologer Ramraj
                            </div>
                          </div>
                          <div className={styles.frameParent2}>
                            <div className={styles.groupContainer}>
                              <div className={styles.div1}>Specialties</div>
                              <div className={styles.wrapper}>
                                <div
                                  className={styles.div2}
                                >{`Love, Business, Life `}</div>
                              </div>
                            </div>
                            <div className={styles.groupContainer}>
                              <div className={styles.div3}>Skills</div>
                              <div
                                className={styles.div4}
                              >{`Vedic Astrology, Kundali, `}</div>
                            </div>
                          </div>
                        </div>
                        <div className={styles.container}>
                          <div className={styles.div2}>Price</div>
                          <div className={styles.frameWrapper5}>
                            <div className={styles.groupFrame}>
                              <div className={styles.statusbusyqueueParent}>
                                <b className={styles.statusbusyqueue}>₹10</b>
                                <b className={styles.min}>/min</b>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className={styles.groupParent1}>
                          <img
                            className={styles.groupChild3}
                            alt=""
                            src="/group-511336.svg"
                          />
                          <div className={styles.iconsaxoutlinecallParent}>
                            <img
                              className={styles.iconsaxoutlinecall}
                              alt=""
                              src="/iconsaxoutlinecall1.svg"
                            />
                            <b className={styles.call}>Call</b>
                          </div>
                          <div className={styles.iconsaxoutlinemessageParent}>
                            <img
                              className={styles.iconsaxoutlinecall}
                              alt=""
                              src="/iconsaxoutlinemessage1.svg"
                            />
                            <b className={styles.call}>Chat</b>
                          </div>
                        </div>
                        <div className={styles.lineDiv} />
                      </div>
                    </div>
                  </div>
                  <div className={styles.groupWrapper22}>
                    <div className={styles.groupWrapper4}>
                      <img
                        className={styles.maskGroupIcon8}
                        alt=""
                        src="/mask-group7@2x.png"
                      />
                      <div className={styles.groupChild39} />
                      <div className={styles.groupChild40} />
                      <div className={styles.groupWrapper23}>
                        <div className={styles.frameWrapper41}>
                          <div className={styles.frameWrapper3}>
                            <div className={styles.frameWrapper4}>
                              <div className={styles.frameWrapper44}>
                                <div className={styles.parent22}>
                                  <img
                                    className={styles.icon}
                                    alt=""
                                    src="/1.svg"
                                  />
                                  <div className={styles.div48}>4.5</div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className={styles.div49}>10+ Years</div>
                      <div className={styles.groupParent16}>
                        <div className={styles.rectangleGroup}>
                          <div className={styles.rectangle} />
                          <b className={styles.online}>Online</b>
                        </div>
                        <img
                          className={styles.ellipseIcon}
                          alt=""
                          src="/ellipse-15281.svg"
                        />
                      </div>
                      <div className={styles.frameParent19}>
                        <div className={styles.astrologerRamrajWrapper}>
                          <div className={styles.astrologerRamraj}>
                            Astrologer Ramraj
                          </div>
                        </div>
                        <div className={styles.frameParent2}>
                          <div className={styles.groupContainer}>
                            <div className={styles.div1}>Specialties</div>
                            <div className={styles.wrapper}>
                              <div
                                className={styles.div2}
                              >{`Love, Business, Life `}</div>
                            </div>
                          </div>
                          <div className={styles.groupContainer}>
                            <div className={styles.div3}>Skills</div>
                            <div
                              className={styles.div4}
                            >{`Vedic Astrology, Kundali, `}</div>
                          </div>
                        </div>
                      </div>
                      <div className={styles.parent25}>
                        <div className={styles.div2}>Price</div>
                        <div className={styles.frameWrapper5}>
                          <div className={styles.groupFrame}>
                            <div className={styles.statusbusyqueueParent}>
                              <b className={styles.statusbusyqueue}>₹10</b>
                              <b className={styles.min}>/min</b>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className={styles.groupParent17}>
                        <img
                          className={styles.groupChild3}
                          alt=""
                          src="/group-511337.svg"
                        />
                        <div className={styles.iconsaxoutlinecallParent6}>
                          <img
                            className={styles.iconsaxoutlinecall}
                            alt=""
                            src="/iconsaxoutlinecall2.svg"
                          />
                          <b className={styles.call}>Call</b>
                        </div>
                        <div className={styles.iconsaxoutlinemessageParent6}>
                          <img
                            className={styles.iconsaxoutlinecall}
                            alt=""
                            src="/iconsaxoutlinemessage4.svg"
                          />
                          <b className={styles.call}>Chat</b>
                        </div>
                      </div>
                      <div className={styles.groupChild43} />
                      <div className={styles.div55}>4.7</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={styles.frameParent21}>
          <div className={styles.frameWrapper46}>
            <div className={styles.frameParent22}>
              <div className={styles.vectorGroup}>
                <img className={styles.vectorIcon1} alt="" src="/vector1.svg" />
                <b className={styles.premiumAstrologers}>User Review</b>
                <img className={styles.vectorIcon1} alt="" src="/vector1.svg" />
              </div>
              <div className={styles.groupParent18}>
                <div className={styles.groupParent19}>
                  <div className={styles.rectangleParent8}>
                    <div className={styles.groupChild44} />
                    <div className={styles.groupChild45} />
                    <div className={styles.groupChild46} />
                  </div>
                  <div className={styles.groupParent20}>
                    <div className={styles.rectangleParent9}>
                      <div className={styles.groupChild47} />
                      <img
                        className={styles.downArrowIcon}
                        alt=""
                        src="/down-arrow@2x.png"
                      />
                    </div>
                    <div className={styles.rectangleParent10}>
                      <div className={styles.groupChild48} />
                      <img
                        className={styles.downArrowIcon1}
                        alt=""
                        src="/down-arrow1@2x.png"
                      />
                    </div>
                  </div>
                </div>
                <div className={styles.exploreTheMysteriesOfTheUParent}>
                  <div
                    className={styles.exploreTheMysteries}
                  >{`Explore the Mysteries of the Universe with Our Expert Astrology Services Explore the Mysteries of the Universe with Our Expert Astrology ServicesExplore the Mysteries of the Universe with `}</div>
                  <div className={styles.frameParent23}>
                    <div className={styles.ellipseGroup}>
                      <img
                        className={styles.frameInner}
                        alt=""
                        src="/ellipse-1628@2x.png"
                      />
                      <div className={styles.harshPatel}>Harsh Patel</div>
                    </div>
                    <div className={styles.ellipseContainer}>
                      <img
                        className={styles.frameChild1}
                        alt=""
                        src="/ellipse-1629@2x.png"
                      />
                      <img
                        className={styles.frameChild1}
                        alt=""
                        src="/ellipse-1630@2x.png"
                      />
                      <img
                        className={styles.frameChild1}
                        alt=""
                        src="/ellipse-1631@2x.png"
                      />
                    </div>
                    <div className={styles.ellipseParent1}>
                      <img
                        className={styles.frameChild1}
                        alt=""
                        src="/ellipse-1632@2x.png"
                      />
                      <img
                        className={styles.frameChild1}
                        alt=""
                        src="/ellipse-1633@2x.png"
                      />
                      <img
                        className={styles.frameChild1}
                        alt=""
                        src="/ellipse-1634@2x.png"
                      />
                    </div>
                  </div>
                  <div className={styles.parent26}>
                    <img className={styles.icon1} alt="" src="/11.svg" />
                    <img className={styles.icon1} alt="" src="/2.svg" />
                    <img className={styles.icon1} alt="" src="/3.svg" />
                    <img className={styles.icon1} alt="" src="/4.svg" />
                    <img className={styles.icon1} alt="" src="/5.svg" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <img
            className={styles.groupChild49}
            alt=""
            src="/frame-48096296.svg"
          />
        </div>
        <div className={styles.groupChild50} />
        <div className={styles.groupChild51} />
        <div className={styles.vectorParent1}>
          <img className={styles.vectorIcon1} alt="" src="/vector2.svg" />
          <b className={styles.premiumAstrologers}>Many Problem one Solution</b>
          <img className={styles.vectorIcon1} alt="" src="/vector2.svg" />
        </div>
        <div className={styles.groupChild52} />
        <img
          className={styles.trustBanner21}
          alt=""
          src="/trust-banner2-1@2x.png"
        />
        <img className={styles.groupChild53} alt="" src="/group-47786.svg" />
        <div className={styles.frameParent24}>
          <div className={styles.groupParent21}>
            <div className={styles.rectangleParent11}>
              <div className={styles.groupChild54} />
              <div className={styles.loveRelatedProblemContainer}>
                <p className={styles.loveRelated}>{`Love Related `}</p>
                <p className={styles.loveRelated}>{`Problem `}</p>
              </div>
              <img
                className={styles.groupChild55}
                alt=""
                src="/group-51196.svg"
              />
            </div>
            <div className={styles.rectangleParent12}>
              <div className={styles.groupChild56} />
              <div className={styles.marriageProblem}>Marriage Problem</div>
              <img
                className={styles.groupChild57}
                alt=""
                src="/group-51198.svg"
              />
            </div>
            <div className={styles.rectangleParent13}>
              <div className={styles.groupChild58} />
              <div className={styles.jobbusinessProblems}>
                Job/Business Problems
              </div>
              <img
                className={styles.groupChild59}
                alt=""
                src="/group-51200.svg"
              />
            </div>
            <div className={styles.rectangleParent14}>
              <div className={styles.groupChild60} />
              <img
                className={styles.rectangleIcon}
                alt=""
                src="/rectangle-18807.svg"
              />
              <div className={styles.moneyProblem}>Money Problem</div>
              <img
                className={styles.rupeesCoinsIcon}
                alt=""
                src="/rupees-coins.svg"
              />
            </div>
            <div className={styles.rectangleParent11}>
              <div className={styles.groupChild54} />
              <div className={styles.educationProblems}>Education Problems</div>
              <img
                className={styles.groupChild55}
                alt=""
                src="/group-51203.svg"
              />
            </div>
          </div>
          <div className={styles.groupParent22}>
            <div className={styles.rectangleParent11}>
              <div className={styles.groupChild54} />
              <img
                className={styles.groupChild64}
                alt=""
                src="/rectangle-18804.svg"
              />
              <div className={styles.healthProblems}>Health Problems</div>
              <img
                className={styles.medicalSignIcon}
                alt=""
                src="/medical-sign.svg"
              />
            </div>
            <div className={styles.rectangleParent11}>
              <div className={styles.rectangleGroup}>
                <div className={styles.groupChild54} />
                <img
                  className={styles.groupChild64}
                  alt=""
                  src="/rectangle-18811.svg"
                />
              </div>
              <div className={styles.grahShanti}>Grah Shanti</div>
              <img className={styles.orbitIcon} alt="" src="/orbit.svg" />
            </div>
            <div className={styles.rectangleParent18}>
              <div className={styles.groupChild67} />
              <img
                className={styles.groupChild68}
                alt=""
                src="/rectangle-18813.svg"
              />
              <div className={styles.childBirthIssues}>Child Birth Issues</div>
              <img className={styles.birthIcon} alt="" src="/birth.svg" />
            </div>
            <div className={styles.rectangleParent14}>
              <div className={styles.groupChild60} />
              <img
                className={styles.groupChild70}
                alt=""
                src="/rectangle-18815.svg"
              />
              <div className={styles.husbandWifeProblems}>
                Husband Wife Problems
              </div>
              <img
                className={styles.familyCareIcon}
                alt=""
                src="/family-care.svg"
              />
            </div>
            <div className={styles.rectangleParent11}>
              <div className={styles.groupChild54} />
              <div className={styles.luckyNumber}>Lucky Number / Color</div>
              <img
                className={styles.groupChild64}
                alt=""
                src="/group-51190.svg"
              />
            </div>
          </div>
        </div>
        <img
          className={styles.component43Icon}
          alt=""
          src="/component-43.svg"
        />
        <img className={styles.groupChild73} alt="" src="/frame-48096375.svg" />
        <div className={styles.component42Parent}>
          <img
            className={styles.component42Icon}
            alt=""
            src="/component-42.svg"
          />
          <div className={styles.vectorGroup}>
            <img className={styles.vectorIcon1} alt="" src="/vector1.svg" />
            <b className={styles.premiumAstrologers}>User Testimonial</b>
            <img className={styles.vectorIcon1} alt="" src="/vector1.svg" />
          </div>
        </div>
        <img className={styles.groupChild74} alt="" src="/group-51456.svg" />
        <div className={styles.frameParent25}>
          <img
            className={styles.frameChild7}
            alt=""
            src="/frame-48095739.svg"
          />
          <img className={styles.frameChild7} alt="" src="/frame-47663.svg" />
        </div>
        <div className={styles.rectangleParent21}>
          <div className={styles.groupChild75} />
          <img className={styles.groupChild76} alt="" src="/frame-47374.svg" />
          <div className={styles.companyParent}>
            <div className={styles.company}>Company</div>
            <div className={styles.homeGroup}>
              <div className={styles.privacyPolicy}>Home</div>
              <div className={styles.privacyPolicy}>Privacy Policy</div>
              <div className={styles.privacyPolicy}>{`T &C`}</div>
              <div className={styles.privacyPolicy}>Varied Payment</div>
            </div>
          </div>
          <div className={styles.collaborateParent}>
            <div className={styles.collaborate}>Collaborate</div>
            <div className={styles.homeGroup}>
              <div className={styles.privacyPolicy}>Clever Tap</div>
              <div className={styles.privacyPolicy}>Exotel</div>
              <div className={styles.privacyPolicy}>Facebook</div>
              <div className={styles.privacyPolicy}>Quora</div>
              <div className={styles.privacyPolicy}>Google</div>
              <div className={styles.privacyPolicy}>Youtube</div>
            </div>
          </div>
          <div className={styles.importantLinkParent}>
            <div className={styles.collaborate}>Important Link</div>
            <div className={styles.homeGroup}>
              <div className={styles.privacyPolicy}>Tarot Reader</div>
              <div className={styles.privacyPolicy}>{`Vedic Astrology `}</div>
              <div className={styles.privacyPolicy}>{`Palmistry `}</div>
              <div className={styles.privacyPolicy}>Gemology</div>
              <div className={styles.privacyPolicy}>Vastu</div>
              <div className={styles.privacyPolicy}>Numerology</div>
            </div>
          </div>
          <div className={styles.supportParent}>
            <div className={styles.company}>Support</div>
            <div className={styles.privacyPolicyParent}>
              <div className={styles.privacyPolicy1}>Privacy Policy</div>
              <div className={styles.home2}>Home</div>
              <div className={styles.variedPayment1}>Varied Payment</div>
              <div className={styles.tC1}>{`T &C`}</div>
            </div>
          </div>
          <div className={styles.frameParent26}>
            <div className={styles.groupParent24}>
              <div className={styles.rectangleParent22}>
                <div className={styles.groupChild77} />
                <div className={styles.yourName}>Your Name</div>
              </div>
              <div className={styles.rectangleParent22}>
                <div className={styles.groupChild77} />
                <div className={styles.mailId}>Mail ID</div>
              </div>
              <div className={styles.rectangleParent24}>
                <div className={styles.groupChild77} />
                <div className={styles.mailId}>Mobile Number</div>
              </div>
              <div className={styles.rectangleParent25}>
                <div className={styles.groupChild80} />
                <div className={styles.mailId}>Write Query</div>
              </div>
            </div>
            <div className={styles.groupWrapper25}>
              <div className={styles.rectangleParent26}>
                <div className={styles.groupChild81} />
                <div className={styles.submit}>Submit</div>
              </div>
            </div>
          </div>
          <div className={styles.groupWrapper26}>
            <div className={styles.ellipseParent2}>
              <img
                className={styles.groupChild82}
                alt=""
                src="/ellipse-1551.svg"
              />
              <div className={styles.guruji}>Guruji</div>
              <img
                className={styles.groupChild83}
                alt=""
                src="/group-50778.svg"
              />
              <img className={styles.layer3Icon1} alt="" src="/layer-3.svg" />
              <img className={styles.objectsIcon1} alt="" src="/objects.svg" />
            </div>
          </div>
          <div className={styles.aboutGurujiS2}>
            About Guruji s2 to 3 lines what guruji do and how it works About
            Guruji s2 to 3 lines what guruji do and how it works
          </div>
          <div className={styles.trustedSeals}>{`Trusted & Seals`}</div>
          <div className={styles.rectangleParent27}>
            <div className={styles.groupChild84} />
            <img className={styles.vectorIcon9} alt="" src="/vector3.svg" />
          </div>
          <img className={styles.groupChild85} alt="" src="/group-51458.svg" />
          <img className={styles.groupChild86} alt="" src="/group-51459.svg" />
        </div>
      </div>
      <div className={styles.frameParent27}>
        <div className={styles.groupParent25}>
          <img className={styles.frameChild9} alt="" src="/group-50600.svg" />
          <div className={styles.x7Customer}>24 X 7 Customer Support</div>
        </div>
        <div className={styles.groupParent25}>
          <img className={styles.frameChild10} alt="" src="/group-50998.svg" />
          <div className={styles.refundIfUnsatisfied}>
            100% Refund if Unsatisfied
          </div>
        </div>
        <div className={styles.groupParent25}>
          <img className={styles.frameChild11} alt="" src="/group-50602.svg" />
          <div
            className={styles.privateConfidential}
          >{`Private & Confidential`}</div>
        </div>
        <div className={styles.groupParent25}>
          <img className={styles.frameChild12} alt="" src="/group-50603.svg" />
          <div className={styles.privateConfidential}>Verified Astrologer</div>
        </div>
        <div className={styles.groupParent25}>
          <img className={styles.frameChild13} alt="" src="/group-50604.svg" />
          <div className={styles.securePayment}>Secure Payment</div>
        </div>
      </div>
      <img className={styles.desktop94Item} alt="" src="/group-477861.svg" />
    </div>
  );
};

export default Desktop94;
